import { tccf7Logger } from './tccf7ErrorHandler.js';

/*-------------------------------------------------------------------------------

  シングルトン：Contact Form 7 イベント管理

--------------------------------------------------------------------------------*/
export default class tccf7EventManager {
  static #instances = new Map();
  static #globalListenersRegistered = false;

  /*----------------------------------------
    インスタンスを取得する静的メソッド
  ------------------------------------------*/
  /**
   * @param {string} formId 
   */
  static getInstance(formId) {
    if ( !formId ) return null; 
    
    const id = String(formId);
    if (!this.#instances.has(id)) {
      this.#instances.set(id, new tccf7EventManager(id));
    }
    
    // グローバルリスナーを一度だけ登録
    if (!this.#globalListenersRegistered) {
      this.#registerGlobalListeners();
      this.#globalListenersRegistered = true;
    }
    
    return this.#instances.get(id);
  }

  constructor(formId) {
    this.formId = formId;
    this.callbacks = {
      invalid      : [],
      mailsent     : [],
      mailfailed   : [],
      ajaxerror    : [],
      beforesubmit : []
    };
    this.isBeforeSubmitRegistered = false;
  }

  /*----------------------------------------
    グローバルイベント（wpcf7～系）の管理
  ------------------------------------------*/
  static #registerGlobalListeners() {
    const events = ['invalid', 'mailsent', 'mailfailed', 'ajaxerror'];
    
    events.forEach(type => {
      document.addEventListener(`wpcf7${type}`, (event) => {
        const id = String(event.detail.contactFormId);
        const instance = this.#instances.get(id);
        instance?.triggerCallbacks(type, event);
      });
    });
  }

  /*----------------------------------------
    beforesubmit の個別登録（CF7仕様への最適化）
  ------------------------------------------*/
  /**
   * @param {HTMLFormElement} form
   */
  registerBeforeSubmit(form) {
    if (this.isBeforeSubmitRegistered || !form) return;

    form.addEventListener('wpcf7beforesubmit', (event) => {
      this.triggerCallbacks('beforesubmit', event);
    });
    this.isBeforeSubmitRegistered = true;
  }

  /*----------------------------------------
    コールバック登録
  ------------------------------------------*/
  /**
   * @param {'invalid'|'mailsent'|'mailfailed'|'ajaxerror'|'beforesubmit'} eventType
   * @param {Function} callback
   */
  on(eventType, callback) {
    if (this.callbacks[eventType]) {
      this.callbacks[eventType].push(callback);
    }
  }

  /*----------------------------------------
    コールバック解除
  ------------------------------------------*/
  /**
   * @param {'invalid'|'mailsent'|'mailfailed'|'ajaxerror'|'beforesubmit'} eventType
   * @param {Function} callback
   */
  off(eventType, callback) {
    if (this.callbacks[eventType]) {
      this.callbacks[eventType] = this.callbacks[eventType].filter(cb => cb !== callback);
    }
  }

  /*----------------------------------------
    登録されたコールバックを実行
  ------------------------------------------*/
  /**
   * @param {'invalid'|'mailsent'|'mailfailed'|'ajaxerror'|'beforesubmit'} eventType
   * @param {Event} event
   */
  triggerCallbacks(eventType, event) {
    this.callbacks[eventType]?.forEach(callback => {
      try {
        callback(event);
      } catch (error) {
        tccf7Logger.log(`EventManager:${eventType}`, error);
      }
    });
  }

  /*----------------------------------------
    全コールバックをクリア
  ------------------------------------------*/
  clearAll() {
    Object.keys(this.callbacks).forEach(key => {
      this.callbacks[key] = [];
    });
  }

  /*----------------------------------------
    インスタンスを削除
  ------------------------------------------*/
  static removeInstance(formId) {
    const id = String(formId);
    const instance = this.#instances.get(id);
    if (instance) {
      instance.clearAll();
      this.#instances.delete(id);
    }
  }
}